export const messages = {
  required: {
    hint: {
      id: 'acceptTermsOfUse.Required.Hint',
      defaultMessage: 'To continue, please read and accept the Terms of Use below.',
    },
  },
  declare: {
    label: {
      id: 'acceptTermsOfUse.Declare.Label',
      defaultMessage: 'I accept the Terms of Use',
    },
    error: {
      id: 'acceptTermsOfUse.Declare.Error',
      defaultMessage: 'You must accept the terms of use to continue.',
    },
  },
  buttons: {
    continue: {
      id: 'acceptTermsOfUse.Buttons.Continue',
      defaultMessage: 'Continue',
    },
    cancel: {
      id: 'acceptTermsOfUse.Buttons.Cancel',
      defaultMessage: 'Cancel',
    },
  },
};
